import { render, staticRenderFns } from "./WarningMatchFound.vue?vue&type=template&id=0ef81244&scoped=true&"
import script from "./WarningMatchFound.vue?vue&type=script&lang=js&"
export * from "./WarningMatchFound.vue?vue&type=script&lang=js&"
import style0 from "./WarningMatchFound.vue?vue&type=style&index=0&id=0ef81244&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef81244",
  null
  
)

export default component.exports